import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { IButton, TranslateService } from '@devinforius/i-essentials';

export const REFUSAL_REASON_MAX_LENGTH = 500;

@Component({
  selector: 'app-refusal-reason-modal',
  standalone: false,
  templateUrl: './refusal-reason-modal.component.html',
  styleUrl: './refusal-reason-modal.component.scss',
})
export class RefusalReasonModalComponent implements OnChanges {
  @Input() public visible = false;
  @Input() public loading = false;
  @Output() public confirmed = new EventEmitter<string>();
  @Output() public canceled = new EventEmitter<void>();

  private translater: TranslateService = inject(TranslateService);

  public readonly maxLength = REFUSAL_REASON_MAX_LENGTH;
  public readonly reason = new FormControl('', {
    nonNullable: true,
    validators: Validators.maxLength(REFUSAL_REASON_MAX_LENGTH),
  });

  private readonly cancelButton: IButton = {
    text: this.translater.translate('global.abort'),
    styleClass: 'blue',
    click: () => this.cancel(),
  };

  private readonly confirmButton: IButton = {
    text: this.translater.translate('global.refuse'),
    styleClass: 'red',
    icon: 'bi bi-x-circle-fill',
    click: () => this.confirm(),
  };

  public readonly buttons: IButton[] = [this.cancelButton, this.confirmButton];

  constructor() {
    this.reason.statusChanges.subscribe(() => this.updateButtonsState());
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']?.currentValue) {
      this.reason.reset('');
    }

    this.updateButtonsState();
  }

  public cancel(): void {
    if (this.loading) {
      return;
    }

    this.canceled.emit();
  }

  private confirm(): void {
    if (this.reason.invalid) {
      return;
    }

    this.confirmed.emit(this.reason.value.trim());
  }

  private updateButtonsState(): void {
    this.cancelButton.disabled = this.loading;
    this.confirmButton.disabled = this.loading || this.reason.invalid;
  }
}
